import React from "react";
import vodafoneLogo from "../../../assets/vodafone-logo.png";
import { BaseBox, BaseLayout, BaseAvatar, BaseTypography } from "../exports";

function AuthLayout({ title, children }) {
  return (
    <BaseLayout
      maxWidth="xs"
      centered
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        pt: 8,
        backgroundColor: "#f5f5f5",
      }}
    >
      {/* Shared Logo + Header */}
      <BaseBox
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          mb: 3,
        }}
      >
        <BaseAvatar
          src={vodafoneLogo}
          alt="Vodafone Logo"
          sx={{ width: 60, height: 60, mb: 1 }}
        />
        <BaseTypography component="h1" variant="h6" textAlign="center">
          {title || "Process Automation Framework"}
        </BaseTypography>
      </BaseBox>

      {/* Page Content */}
      {children}
    </BaseLayout>
  );
}

export default AuthLayout;
